module.exports = __webpack_public_path__ + "img/all-the-best.4b2f7937.svg";